import React from "react";
import FlashMessage from "react-native-flash-message";
import { StyleSheet } from "react-native";
import { StatusBar } from "expo-status-bar";
import { prepareEnv } from "./src/helpers/general";

import App from "./src/components/App";
import Bootstrap from "./src/components/Bootstrap";

const flashStyle = StyleSheet.create({
  text: {
    fontFamily: "Vazir",
    textAlign: "center",
  },
});

prepareEnv();

function BootUp() {
  return (
    <Bootstrap>
      <App />
      <FlashMessage
        position="top"
        textStyle={flashStyle.text}
        titleStyle={flashStyle.text}
      />
      <StatusBar style="auto" />
    </Bootstrap>
  );
}

export default BootUp;
